import type { ReactNode } from 'react';
import { Provider } from 'urql';

import { urqlClient } from '@shared/api';

export function UrqlProvider({ children }: { children: ReactNode }) {
  return <Provider value={urqlClient}>{children}</Provider>;
}
